import React from 'react';
import type { FC } from 'react';

interface UploadIconProps {
    className?: string;
}

export const UploadIcon: FC<UploadIconProps> = ({ className }) => {
    return (
        <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <title>Upload Icon</title>
            <path
                d="M5.33203 17.0667V24.5333C5.33203 25.7115 6.28716 26.6666 7.46536 26.6666H24.532C25.7102 26.6666 26.6654 25.7115 26.6654 24.5333V17.0667"
                strokeWidth="2.13333"
            />
            <path d="M10.668 10.6667L16.0013 5.33341L21.3346 10.6667" strokeWidth="2.13333" strokeLinejoin="round" />
            <path d="M16 5.33327L16 20.2666" stroke="white" strokeWidth="2.13333" />
        </svg>
    );
};
